import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Panel, FormGroup, FormControl, Button } from 'react-bootstrap';
import DateTime from 'react-datetime';
import SubmissionsSearchField from './submissions-search-field';

const objectiveNameSelect = (postcodePlanObjectiveId, onPostcodeplanObjectiveChange, postCodeplanObjectives) => (
  <Col md={3}>
    <FormGroup>
      Price IT + objective Name
      <FormControl
        value={postcodePlanObjectiveId}
        onChange={onPostcodeplanObjectiveChange}
        componentClass="select"
      >
        <option value={''}>ALL</option>
        {postCodeplanObjectives
     && postCodeplanObjectives.map(({label, value}) => (<option key={value} value={value}>{label}</option>))}
      </FormControl>
    </FormGroup>
  </Col>
);

const SubmissionSearch = props => (
  <Panel className="submission-filter">
    <Row>
      <SubmissionsSearchField
        outletCode={props.outletCode}
        onOutletCodeChange={props.onOutletCodeChange}
      />
      <Col md={3}>
        <FormGroup>
          Upload date from
          <DateTime
            timeFormat={false}
            dateFormat="DD/MM/YYYY"
            value={props.dateFromValue}
            onChange={props.onDateFromChange}
            closeOnSelect
            inputProps={{
              placeholder: 'Date from'
            }}
          />
        </FormGroup>
      </Col>
      <Col md={3}>
        <FormGroup>
          Upload date to
          <DateTime
            timeFormat={false}
            dateFormat="DD/MM/YYYY"
            value={props.dateToValue}
            onChange={props.onDateToChange}
            closeOnSelect
            inputProps={{
              placeholder: 'Date to'
            }}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      {!props.isTeamRoute && (
        <Col md={3}>
          <FormGroup>
            Submission type
            <FormControl
              value={props.submissionType}
              onChange={props.onTypeChange}
              componentClass="select"
            >
              <option value={''}>ALL</option>
              {!props.isAuditRoute && (<option value={'SELL IT'}>SELL IT (Tobacco)</option>)}
              <option value={'PRICE IT +'}>PRICE IT +</option>
              <option value={'NGP'}>BLU BAR SELL IT</option>
            </FormControl>
          </FormGroup>
        </Col>
      )}
      <Col md={3}>
        <FormGroup>
          Status
          <FormControl
            value={props.status}
            onChange={props.onStatusChange}
            componentClass="select"
          >
            <option>ALL</option>
            {props.statusTypes &&
              props.statusTypes.map((statusType, index) => <option key={index} value={statusType}>{statusType}</option>)}
          </FormControl>
        </FormGroup>
      </Col>
      {!props.isAuditRoute && (
        <Col md={3}>
          <FormGroup>
            Audit Complete
            <FormControl
              value={props.auditCompleted}
              onChange={props.onAuditCompletedChange}
              componentClass="select"
            >
              <option></option>
              <option key value={1}>Y</option>
              <option key={false} value={0}>N</option>
            </FormControl>
          </FormGroup>
        </Col>
      )}
      {(props.isTeamRoute || props.isAuditRoute) && objectiveNameSelect(
        props.postcodePlanObjectiveId,
        props.onPostcodeplanObjectiveChange,
        props.postCodeplanObjectives
      )}
    </Row>
    {!props.isTeamRoute && !props.isAuditRoute && (
      <Row>
        {objectiveNameSelect(
          props.postcodePlanObjectiveId,
          props.onPostcodeplanObjectiveChange,
          props.postCodeplanObjectives
        )}
      </Row>
    )}
    {props.isAuditRoute && (
      <Row>
        <Col md={3}>
          <FormGroup>
                Savi auditor ID
            <FormControl
              value={props.auditorUser}
              onChange={props.onAuditUserChange}
              componentClass="select"
            >
              <option value={''}>ALL</option>
              {props.auditorUsers &&
                props.auditorUsers.map(user => <option key={user.id} value={user.id}>{user.id} - {user.email}</option>)}
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            Total pending submissions
            <FormControl
              value={props.pendings}
              disabled
            >
            </FormControl>
          </FormGroup>
        </Col>
      </Row>
    )}
    <Row>
      {!props.isAuditRoute && (
        <Col md={6} className="actions" style={{marginTop: '20px'}}>
          {!props.isTeamRoute && (
          <Button
            className="red-ghost-btn"
            onClick={props.onValidateAllChecked}
          >
            Validate all checked
          </Button>
          )}
          <Button
            className="red-ghost-btn"
            onClick={props.onDeclineAllChecked}
          >
            Decline all checked
          </Button>
        </Col>
      )}
      <Col md={6} className="actions" style={{marginTop: '20px'}}>
        <Button
          className="red-ghost-btn"
          onClick={props.onClear}
        >Clear search/filters
        </Button>
        <Button
          className="red-ghost-btn"
          onClick={props.onSearch}
        >Search
        </Button>
      </Col>
    </Row>
  </Panel>
);

const mapStateToProps = state => ({
  isTeamRoute: state.router.location.pathname.includes('team'),
  isAuditRoute: state.router.location.pathname.includes('audit')
});

export default connect(mapStateToProps)(SubmissionSearch);



// WEBPACK FOOTER //
// ./src/components/admin/submissions/list/submissions-search.jsx